import { BaseService } from 'services/baseService';
import { CustomerModel } from 'types/models/CustomerModel';

class CustomerService extends BaseService<CustomerModel> {
  controllerName = 'customer';
}

export const customerService = new CustomerService();
